import { Component, Inject, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { MasterService } from "@frontend/app/serivces/master.service";
import { Cls_AreaData } from "@frontend/app/models/master";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "@frontend/app/serivces/toastr.service";
import { MultiSelectDropdownComponent } from "@frontend/app/components/multi-select-dropdown/multi-select-dropdown.component";
import { SVG_ICONS } from "@frontend/app/models/icons";
@Component({
  selector: "app-add-area",
  imports: [CommonModule, SharedModule, MultiSelectDropdownComponent],
  templateUrl: "./add-area.component.html",
  styleUrl: "./add-area.component.scss",
})
export class AddAreaComponent implements OnInit {
  private masterService = inject(MasterService);
  private toastrService = inject(ToastrService);
  private dialogRef = inject(MatDialogRef<AddAreaComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }
  ngOnInit(): void {
    if (this.data?.areaId) {
      this.areaData.AreaID = this.data.areaId;
      this.getAreaDetailsByID(this.data.areaId);
    }
    this.getRegionList();
  }
  //#region variables
  regionList: any;
  areaData= new Cls_AreaData()
  isRegionDropdownOpen = false;
  isCityDropdownOpen = false;
  ErrorMsg: string[] = [];
  readonly SVG_ICONS = SVG_ICONS;

  //#endregion

  onRegionChange(regionId: number): void {
    if (this.areaData) {
      this.areaData.RegionID = regionId;
    }
  }

  validateForm(): boolean {
    // Check AreaName
    if (!this.areaData.AreaName || !this.areaData.AreaName.trim()) {
      this.toastrService.error("Area Name is required");
      return false;
    }

    // Check RegionID
    if (!this.areaData.RegionID || this.areaData.RegionID <= 0) {
      this.toastrService.error("Please select a valid Region");
      return false;
    }

    return true;
  }

  getRegionList() {
    this.masterService.getRegionList().subscribe((res: any) => {
      const { Table } = res;
      this.regionList = Table.filter((item: any) => item.IsActive);
    });
  }

  getAreaDetailsByID(id: number) {
    this.masterService.getAreaDetailsByID(id).subscribe((res: any) => {
      this.areaData = res;
    });
  }

  // onRegionChange() {
  //   // Reset selected city when region changes
  //   this.selectedCity = null;

  //   if (this.selectedRegion) {
  //     // Filter cities based on selected region
  //     this.filteredCities = this.allCities.filter(city => city.RegionID === this.selectedRegion?.RegionID);
  //   } else {
  //     // If no region is selected, show all cities
  //     this.filteredCities = [...this.allCities];
  //   }
  // }

  onSubmit() {
    if (!this.validateForm()) return;

    const tempModal = new Cls_AreaData();
    tempModal.AreaID = this.areaData.AreaID || 0;
    tempModal.RegionID = this.areaData.RegionID ;
    tempModal.AreaName = this.areaData.AreaName;
    tempModal.IsActive = true;


    if (this.areaData?.AreaID) {
      this.masterService.updateArea(tempModal, this.areaData?.AreaID).subscribe((res: any) => {
        this.toastrService.success("Area updated successfully");
        this.dialogRef.close(res);
      });
    } else {
      this.masterService.addArea(tempModal).subscribe((res: any) => {
        this.toastrService.success("Area added successfully");
        this.dialogRef.close(res);
      });
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
